export const columnTranslations: Record<string, string> = {
  // common columns
  id: "ID",
  is_active: "Активен?",
  created_at: "Создан",
  updated_at: "Обновлен",
  published_at: "Опубликован",

  user_id: "ID пользователя",
  detail: "Детали",

  title: "Заголовок",
  description: "Описание",
  price: "Цена",

  image_path: "Путь изображения",
  category_id: "ID категории",
  image_path_id: "ID изображения",

  content_0: "Колонка 1",
  content_1: "Колонка 2",
  preview_text: "Начальный текст",
  is_published: "Опубликован?",
  preview_image_id: "ID изображения",

  surname: "Фамилия",
  name: "Имя",
  patronymic: "Отчество",
  position_at_work: "Должность",
  age: "Возраст",

  service_id: "ID услуги",
  services_id: "Услуга",

  avatar_path_id: "ID аватарки",
  sertificate_path_id: "ID сертификатов",
  work_path_id: "ID работ",

  phone: "Номер телефона",
  email: "E-mail",
  is_processed: "Обработан?",

  // video columns (важно для вкладки "Видео")
  path: "Путь к видео",

  // tableList (названия таблиц слева)
  blog_post: "Акции",
  service: "Услуги",
  price_list: "Список цен",
  feedback: "Обратная связь",
  employee: "Сотрудники",
  clinic_info: "Информация о клинике",
  gallery: "Галерея",
  category: "Категория изображения",

  video_id: 'Видео',

  video: "Видео",
  videos: "Видео",
  direction_key: "Направления",
  
  how_treatment: "Рекомендации",
  includes_in_price: "Показания",
  employee_work: "Выполненные работы",
  employee_id: "Сотрудник",
  problem: "Проблема",
  solution: "Решение",
  photo_ids: "Фото кейса",
  sort_order: "Порядок",
  __employeeWorks: "Выполненные работы",

};
